// Stable per-device id so a logged-out guest still gets cross-session "seen"
// feed decay. For members the backend uses their user id and ignores this.
const KEY = "samtwo_vk";

export function getViewerKey() {
  try {
    let v = localStorage.getItem(KEY);
    if (!v) {
      v = "anon:" + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now());
      localStorage.setItem(KEY, v);
    }
    return v;
  } catch {
    return null;
  }
}
